import {
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Theme,
} from "@fluentui/react-components";

export type ApprenticeWizardRow = {
  rowKey: string;
  companyName?: string;
  contactName?: string;
  email?: string;
  phone?: string;
  taxNumber?: string;
  status?: number;
};

export const columnSizingOptionsApprenticeWizards = {
  companyName: {
    minWidth: 160,
    defaultWidth: 280,
  },
  contactName: {
    minWidth: 150,
    defaultWidth: 240,
  },
  email: {
    minWidth: 180,
    defaultWidth: 260,
  },
  phone: {
    minWidth: 130,
    defaultWidth: 180,
  },
  taxNumber: {
    minWidth: 120,
    defaultWidth: 170,
  },
  status: {
    minWidth: 110,
    defaultWidth: 140,
  },
};

export const getColumnsApprenticeWizards = (_theme: Theme) =>
  [
    createTableColumn<ApprenticeWizardRow>({
      columnId: "companyName",
      renderHeaderCell: () => "Cégnév",
      renderCell: (item: ApprenticeWizardRow) => (
        <TableCellLayout truncate>{item.companyName ?? ""}</TableCellLayout>
      ),
    } as TableColumnDefinition<ApprenticeWizardRow>),
    createTableColumn<ApprenticeWizardRow>({
      columnId: "contactName",
      renderHeaderCell: () => "Kapcsolattartó",
      renderCell: (item: ApprenticeWizardRow) => (
        <TableCellLayout truncate>{item.contactName ?? ""}</TableCellLayout>
      ),
    } as TableColumnDefinition<ApprenticeWizardRow>),
    createTableColumn<ApprenticeWizardRow>({
      columnId: "email",
      renderHeaderCell: () => "Email",
      renderCell: (item: ApprenticeWizardRow) => (
        <TableCellLayout truncate>{item.email ?? ""}</TableCellLayout>
      ),
    } as TableColumnDefinition<ApprenticeWizardRow>),
    createTableColumn<ApprenticeWizardRow>({
      columnId: "phone",
      renderHeaderCell: () => "Telefon",
      renderCell: (item: ApprenticeWizardRow) => (
        <TableCellLayout truncate>{item.phone ?? ""}</TableCellLayout>
      ),
    } as TableColumnDefinition<ApprenticeWizardRow>),
    createTableColumn<ApprenticeWizardRow>({
      columnId: "taxNumber",
      renderHeaderCell: () => "Adószám",
      renderCell: (item: ApprenticeWizardRow) => (
        <TableCellLayout truncate>{item.taxNumber ?? ""}</TableCellLayout>
      ),
    } as TableColumnDefinition<ApprenticeWizardRow>),
    createTableColumn<ApprenticeWizardRow>({
      columnId: "status",
      renderHeaderCell: () => "Wizard oldal",
      renderCell: (item: ApprenticeWizardRow) => (
        <TableCellLayout truncate>
          {item.status === null || item.status === undefined
            ? ""
            : String(item.status)}
        </TableCellLayout>
      ),
    } as TableColumnDefinition<ApprenticeWizardRow>),
  ] as TableColumnDefinition<ApprenticeWizardRow>[];
